import { PrismState } from "./types";

const state: PrismState = {
  embedType: "USE",
};

export default state;
